export enum StarterBoardModalType {
  ACTIVATED = `activated`,
  FEEDBACK_SURVEY = `feedback survey`,
}
